import update from "immutability-helper";
import { createSlice } from "@reduxjs/toolkit";
import { setNotification, resetNotification } from "./index";

const initialState = null;

const setNotificationHandler = (state, action) => {
  const { tipo, message, description, durata, parametri } = action.payload;
  return update(state, {
    $set: {
      type: tipo,
      message: message,
      description: description,
      duration: durata,
      params: parametri,
    },
  });
};

const resetNotificationHandler = (state) => {
  return update(state, { $set: initialState });
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setNotification, (state, action) => setNotificationHandler(state, action));
    builder.addCase(resetNotification, (state) => resetNotificationHandler(state));
  },
});

export const notificationReducer = notificationSlice.reducer;
